import { RentalUnitTypeEnum } from '../generated/graphql';
import unitTypes from '../constants/unitTypes';

export const getUnitTypeTranslation = (typeEnum?: RentalUnitTypeEnum) =>
    unitTypes.find(type => type.value === typeEnum)?.label;
